import { fetchWithAuth } from './fetchWithAuth';

const CACHE_KEY = 'siteSettings_cache';

export async function getSiteSettings() {
  try {
    const res = await fetch(`${process.env.REACT_APP_BASE_URL || ''}/api/site-settings`);
    if (res.ok) {
      const data = await res.json();
      localStorage.setItem(CACHE_KEY, JSON.stringify(data));
      return data;
    }
  } catch {}
  // fallback to cache
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    if (cached) return JSON.parse(cached);
  } catch {}
  return { confetti: true, ticker: { enabled: true, items: [] }, popup: { enabled: true, title: '', content: '' } };
}

export async function saveSiteSettings(settings) {
  localStorage.setItem(CACHE_KEY, JSON.stringify(settings));
  const res = await fetchWithAuth('/api/site-settings', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(settings),
  });
  if (!res.ok) throw new Error('שמירה נכשלה');
  return res.json();
}
